import { render } from "./TechArticleList.vue?vue&type=template&id=65c8cf79"
import script from "./TechArticleList.vue?vue&type=script&lang=js"
export * from "./TechArticleList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__